




import { Component, Vue, Prop } from "vue-property-decorator";
import { VideoRequestStatus } from "@/api/VideoRequest";
import { videoRequestIcon } from "@/assets/icons/VideoRequestIcons";

@Component
export default class RequestStatusIcon extends Vue {
  @Prop() readonly status?: VideoRequestStatus;

  icon() {
    if (this.status === undefined) return "";
    return videoRequestIcon(this.status);
  }
}
